import React, { useState } from 'react';
import { Button, Flex } from '@cognite/cogs.js';
import { DigitalTwin, SchemaCollection } from 'types/dt-graphql-apollo-v2';
import mixpanel from 'utils/mixpanel-frontend';
import { RuleRunsCount, TitleBar } from 'components';
import { useAccessControl } from 'hooks/useAccessControl';
import { groupedPermissionsList } from 'store/permissions';
import { AddSolutionsDrawer } from './AddSolutionsDrawer';
import { SchemaCardsList } from './SchemaCardsList';

export const Schemas = ({ digitalTwin }: { digitalTwin: DigitalTwin }) => {
  const [showAddSolutionsDrawer, setShowAddSolutionsDrawer] = useState(false);

  const schemaIds =
    digitalTwin?.schemaCollections?.items
      .map((schema) => schema?.externalId)
      .filter((id): id is string => !!id) ?? [];

  const hasAccess = useAccessControl();
  const canCreateSchemaCollection = hasAccess(
    groupedPermissionsList.CAN_CREATE_SCHEMA_COLLECTION
  );

  const onHandleClick = () => {
    setShowAddSolutionsDrawer(true);
    mixpanel.track('Add schemas button', {
      id: digitalTwin?.externalId,
      name: digitalTwin?.name,
    });
  };

  return (
    <>
      <TitleBar heading="Data catalogue" subheading="View your schemas">
        <Flex style={{ padding: '1rem' }}>
          <RuleRunsCount schemaIds={schemaIds} />
        </Flex>
        {canCreateSchemaCollection && (
          <Button
            type="primary"
            icon="AddLarge"
            style={{ marginRight: '1rem' }}
            onClick={() => {
              onHandleClick();
            }}
          >
            Add schema
          </Button>
        )}
      </TitleBar>

      <div style={{ margin: '0 2rem' }}>
        <SchemaCardsList
          schemaCollections={
            digitalTwin?.schemaCollections!.items as SchemaCollection[]
          }
          onCreateNewSchema={() => setShowAddSolutionsDrawer(true)}
        />
        <AddSolutionsDrawer
          onSetShowAddSolutionsDrawer={() => setShowAddSolutionsDrawer(false)}
          digitalTwin={digitalTwin}
          onCancel={() => setShowAddSolutionsDrawer(false)}
          visible={showAddSolutionsDrawer}
        />
      </div>
    </>
  );
};
